import { BcAntenatalRadioTextboxField } from "@/Patient/Models/ObstetricalFile/BritishColumbia/BcAntenatalRadioTextboxField";

class MedicalHistoryImmunizations {
    public HasImmunizations?: boolean = null;
    public Flu: BcAntenatalRadioTextboxField;
    public TetanusDiphtheriaAcellularPertussisVaccine: BcAntenatalRadioTextboxField;
    public Other: BcAntenatalRadioTextboxField;

    public constructor(fields?: Partial<MedicalHistoryImmunizations>) {
        Object.assign(this, fields);
        this.TetanusDiphtheriaAcellularPertussisVaccine = new BcAntenatalRadioTextboxField(fields?.TetanusDiphtheriaAcellularPertussisVaccine);
        this.Other = new BcAntenatalRadioTextboxField(fields?.Other);
        this.Flu = new BcAntenatalRadioTextboxField(fields?.Flu);
    }

    public hasSelectedAnyMedicalHistoryImmunizations(): boolean {
        return this.Flu.hasSelected()
            || this.TetanusDiphtheriaAcellularPertussisVaccine.hasSelected()
            || this.Other.hasSelected();
    }
}

export { MedicalHistoryImmunizations };
